// supabase/functions/_shared/grussformel.ts
// #537: Das E-Mail-Briefpapier hat „Mit freundlichen Grüßen“ fest vor {{signatur}}; viele
// Signaturen bringen die Grußformel selbst mit → doppelt. Bringt die Signatur eine Grußformel
// mit, entfällt die des Briefpapiers direkt vor dem Slot; sonst bleibt sie (z. B. Signatur ohne Gruß).
// Genutzt von der App (lib/emails) und den Edge Functions — reines TS ohne Deno-APIs.

const GRUSS = /(mit\s+)?(freundlichen|besten|herzlichen|lieben|viele[n]?|beste|freundliche|liebe|herzliche)\s+gr(ü|ue|&uuml;|&#252;)(ß|ss|&szlig;|&#223;)(en|e)/i;

/** Enthält das (HTML-)Stück eine Grußformel? */
export function hatGrussformel(html: string | null | undefined): boolean {
  const text = String(html ?? '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ');
  return GRUSS.test(text);
}

/** Entfernt die Grußformel des Briefpapiers unmittelbar vor {{signatur}}, wenn die Signatur selbst eine hat. */
export function ohneDoppeltenGruss(briefpapier: string, signatur: string | null | undefined): string {
  if (!briefpapier.includes('{{signatur}}') || !hatGrussformel(signatur)) return briefpapier;
  return briefpapier.replace(
    /<(p|div|span)\b[^>]*>\s*(mit\s+)?[a-zäöü]+\s+gr(ü|ue|&uuml;|&#252;)(ß|ss|&szlig;|&#223;)(en|e)\s*,?\s*<\/\1>\s*(?=\{\{signatur\}\})/gi,
    '',
  );
}
